module.exports = {
  Position: require('./position'),
  Color: require('./color'),
  Shape: require('./shape'),
  Size: require('./size'),
  Opacity: require('./opacity'),
  ColorUtil: require('./color-util')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_attr@0.1.2@@antv/attr/lib/index.js
// module id = 77
// module chunks = 0 1 2